// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { VDateInput } from 'vuetify/labs/VDateInput'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  components: {
    VDateInput,
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#FFFFFF',        // Pure white (background)
          surface: '#FFFFFF',           // Surface white (for cards, etc)
          'surface-variant': '#F8F8F8', // Light variant (secondary surfaces)
          'surface-bright': '#FCFCFC',  // Bright variant (for inputs, etc)
          'surface-light': '#F5F5F5',   // Light gray variant (for subtler backgrounds)
          primary: '#1976D2',           // Keep the existing primary color
          secondary: '#424242',         // Keep the existing secondary color
          // Other colors remain unchanged
        }
      }
    }
  }
})
